// extracted by mini-css-extract-plugin
export default {"btn":"ChangeQuantity_btn__uvOhY","text":"ChangeQuantity_text__krc9T"};